<template>
  <!-- Main Start -->
  <div class="main">
    <section class="page-body p-0">
      <div class="row">
        <div class="order-2 order-lg-1 col-lg-5">
          <div class="content-box">
            <div>
              <h5>Crear una cuenta</h5>
              <p class="font-md content-color">¡Registrate con nosotros!</p>

              <form action="index.php" class="custom-form form-pill">
                <div class="input-box1">
                  <label for="full-name">Nombres:</label>
                  <input
                    id="full-name"
                    name="full-name"
                    class="form-control"
                    type="text"
                    v-model="name"
                    @input="onlyStringVarcharN"
                    required
                  />
                </div>

                <div class="input-box1">
                  <label for="sur-name">Apellidos:</label>
                  <input
                    id="sur-name"
                    name="sur-name"
                    class="form-control"
                    type="text"
                    v-model="surname"
                    @input="onlyStringVarcharS"
                    required
                  />
                </div>

                <div class="input-box1">
                  <label for="email">Correo electrónico:</label>
                  <input
                    id="email"
                    name="email"
                    class="form-control"
                    type="email"
                    v-model="email"
                    required
                    inputmode="email"
                    autocomplete="email"
                    autocapitalize="off"
                    spellcheck="false"
                    @keypress="allowEmailKeypress"
                    @paste.prevent="handleEmailPaste"
                    @input="sanitizeEmailOnInput"
                  />
                </div>

                <div class="icon-input input-box1">
                  <label for="password">Contraseña:</label>
                  <div class="icon-input">
                    <input
                      id="password"
                      name="password"
                      class="form-control"
                      type="password"
                      v-model="password"
                      required
                    />
                    <img class="showHidePassword" src="/assets/icons/svg/eye-1.svg" alt="eye" />
                  </div>
                </div>

                <button
                  type="button"
                  @click="register()"
                  v-if="!loading"
                  class="btn-solid rounded-pill line-none theme-color"
                >
                  Registrarse
                </button>
                <div class="loader-5 center" v-if="loading"><span></span></div>

                <router-link
                  :to="'/'"
                  class="btn-solid rounded-pill line-none btn-outline mt-3 d-flex justify-content-center"
                >
                  Ir al sitio web
                </router-link>
              </form>

              <span class="backto-link font-default content-color text-decoration-none">
                ¿Ya tienes una cuenta?
                <a class="text-decoration-underline theme-color" @click="tologin()">Iniciar Sesión</a>
              </span>
            </div>
          </div>
        </div>

        <div class="order-1 order-lg-2 col-lg-7">
          <div class="img-box">
            <img class="bg-img" src="/assets/images/bg/bg-zd-000.jpg" alt="banner" />
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Main End -->
</template>

<script>
import { recaptchaPost } from '@/utils/recaptcha'
import myApi from '../../plugins/axios'
import store from '../../plugins/store'
import { useReCaptcha } from 'vue-recaptcha-v3'
// import { checkEmailReputation } from '@/utils/emailReputation'

export default {
  name: 'RegisterSection',
  setup() {
    const { executeRecaptcha } = useReCaptcha()
    return { executeRecaptcha }
  },
  data() {
    return {
      email: null,
      name: null,
      surname: null,
      password: null,
      loading: false,
      gogleIn: {
        email: null,
        name: null,
        surname: null,
        imagen: null,
        google_id: null,
      },
      // whitelist para email: letras, números y @ . _ + -
      emailAllowedRegex: /[a-zA-Z0-9@._+-]/,
    }
  },
  methods: {
    /* ======= Navegación ======= */
    tologin() { this.$router.push({ name: 'Login' }) },
    tohome() { this.$router.push({ name: 'Home' }) },

    /* ======= Validación de nombres ======= */
    onlyStringVarcharN() {
      const regex = /[^A-Za-záéíóúÁÉÍÓÚñÑ\s]/g
      if (regex.test(this.name)) this.name = this.name.replace(regex, '')
    },
    onlyStringVarcharS() {
      const regex = /[^A-Za-záéíóúÁÉÍÓÚñÑ\s]/g
      if (regex.test(this.surname)) this.surname = this.surname.replace(regex, '')
    },

    /* ======= Restricciones de EMAIL (igual que en login) ======= */
    allowEmailKeypress(e) {
      const key = e.key
      const controlKeys = ['Backspace','Delete','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','Tab','Enter']
      if (controlKeys.includes(key)) return
      if (key === ' ') return e.preventDefault()
      if (!this.emailAllowedRegex.test(key)) return e.preventDefault()
      if (key === '@') {
        const current = this.email || ''
        if (current.includes('@')) e.preventDefault()
      }
    },
    handleEmailPaste(e) {
      const text = (e.clipboardData || window.clipboardData).getData('text') || ''
      this.email = this.normalizeEmail(text)
    },
    sanitizeEmailOnInput(e) {
      const value = e.target.value || ''
      const sanitized = this.normalizeEmail(value)
      if (sanitized !== value) this.email = sanitized
    },
    normalizeEmail(text) {
      let cleaned = text
        .replace(/\s+/g, '')                               // sin espacios
        .replace(/['"`<>()[\]{};:\\/|^%$#!?,=~]/g, '')     // limpia especiales comunes
        .split('')
        .filter(ch => this.emailAllowedRegex.test(ch))     // whitelist
        .join('')

      const firstAt = cleaned.indexOf('@')                 // solo un @
      if (firstAt !== -1) {
        const before = cleaned.slice(0, firstAt + 1)
        const after = cleaned.slice(firstAt + 1).replace(/@/g, '')
        cleaned = before + after
      }

      if (cleaned.length > 254) cleaned = cleaned.slice(0, 254)
      return cleaned
    },

    /* ======= Registro ======= */
    async register() {
      try {
        // validación simple de formato antes de enviar
        if (!this.email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(this.email)) {
          this.$notify({ title: 'VALIDACIÓN', text: 'Ingresa un correo electrónico válido.', duration: 3500, type: 'error' })
          return
        }
        if (!this.name || !this.surname || !this.password) {
          this.$notify({ title: 'VALIDACIÓN', text: 'Completa todos los campos requeridos.', duration: 3000, type: 'error' })
          return
        }

        // ======= Verificación de reputación (por backend) =======
        //SE IMPLEMENTO LA VALIDACION DE EMAIL REPUTATION DESDE EL BACKEND PERO EL CLIENTE SOLO PAGO EL PLANBASICO Y SE TERMINO LOS TOKENS DE LA APO
        // const rep = await checkEmailReputation(this.email, { blockOnError: true })

        // if (!rep.ok) {
        //   let msg = 'El correo parece desechable o con mala reputación. Usa otro email.'

        //   // Caso genérico: proveedor no disponible / límite alcanzado (429/422/timeout)
        //   if (rep.reason === 'verification_unavailable') {
        //     msg = 'No se pudo verificar el correo en este momento. Inténtalo de nuevo en unos segundos.'
        //   } else if (rep.details) {
        //     const { isDisposable, deliverability, isMxFound, qualityScore } = rep.details
        //     if (isDisposable) {
        //       msg = 'No aceptamos correos desechables. Por favor utiliza un correo permanente.'
        //     } else if (deliverability === 'UNDELIVERABLE') {
        //       msg = 'El dominio del correo no es entregable. Revisa o usa otro correo.'
        //     } else if (isMxFound === false) {
        //       msg = 'El dominio del correo no tiene registros válidos.'
        //     } else if (
        //       typeof qualityScore === 'number' &&
        //       qualityScore < Number(process.env.VUE_APP_ABSTRACT_EMAIL_MIN_SCORE || 0.3)
        //     ) {
        //       msg = 'El correo tiene un puntaje de calidad bajo.'
        //     }
        //   }

        //   this.$notify({ title: 'VALIDACIÓN', text: msg, duration: 3500, type: 'error' })
        //   return
        // }
        // ======= FIN verificación =======

        this.loading = true
        const resp = await recaptchaPost(
          this.executeRecaptcha,
          'register',
          'ecommerce/register',
          {
            surname: this.surname,
            name: this.name,
            email: this.email,
            password: this.password,
          }
        )
        this.loading = false

        this.$notify({ title: `${resp.data.message}`, duration: 3500 })


        // Guarda credenciales para auto-login post-OTP
sessionStorage.setItem('pendingLogin', JSON.stringify({
  email: this.email,
  password: this.password
}))

this.$router.push({
  name: 'OtpValidate',
  query: { email: this.email }
})

        this.$router.push({
          name: 'OtpValidate',
          query: { email: this.email }
        })
      } catch (error) {
        this.loading = false
        for (let key in (error?.response?.data?.error || {})) {
          this.$notify({
            title: 'VALIDACIÓN',
            text: error.response.data.error[key] ?? 'Comuníquese con Atención al Cliente',
            duration: 3500,
            type: 'error',
          })
        }
      }
    },

    /* ======= (opcional) login directo post-registro ======= */
    async login() {
      try {
        const resp = await myApi.post('ecommerce/login', { email: this.email, password: this.password })
        if (resp.data.error) {
          for (let key in resp.data.error) {
            this.$notify({ title: 'VALIDACIÓN', text: resp.data.error[key], duration: 3500, type: 'error' })
          }
        } else {
          store.dispatch('saveToken', { token: resp.data.token, user: resp.data.user })
          setTimeout(() => { window.location.href = process.env.VUE_APP_FRONTED + 'perfil-cliente?perfil=1' }, 50)
        }
      } catch (err) {
        if (err.response?.data) {
          this.$notify({ title: 'VALIDACIÓN', text: err.response.data.message, duration: 3500, type: 'error' })
        } else {
          this.$router.push({ name: 'Login' })
          this.$notify({ title: 'VALIDACIÓN', text: 'Hubo un error al intentar registrarse, intentalo nuevamente', duration: 3500, type: 'error' })
        }
      }
    },

    decodeJwtResponse(token) {
      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))
      return JSON.parse(jsonPayload)
    },
  },

  mounted() {
    // (sin logs)
    const script2 = document.createElement('script')
    script2.src = '../../assets/js/password-showhide.js'
    document.body.appendChild(script2)

    window.handleCredentialResponse = async (response) => {
      const responsePayload = this.decodeJwtResponse(response.credential)
      this.gogleIn.email = responsePayload.email
      this.gogleIn.name = responsePayload.given_name
      this.gogleIn.surname = responsePayload.family_name
      this.gogleIn.imagen = responsePayload.picture
      this.gogleIn.google_id = responsePayload.sub

      try {
        const resp = await myApi.post('ecommerce/login-google', { google: this.gogleIn })
        if (resp.data.error) {
          for (let key in resp.data.error) {
            this.$notify({ title: 'VALIDACIÓN', text: resp.data.error[key], duration: 3500, type: 'error' })
          }
        } else {
          store.dispatch('saveToken', { token: resp.data.token, user: resp.data.user })
          setTimeout(() => { window.location.href = process.env.VUE_APP_FRONTED }, 50)
        }
      } catch (err) {
        if (err.response?.data) {
          this.$notify({ title: 'VALIDACIÓN', text: err.response.data.message, duration: 3500, type: 'error' })
        } else {
          this.$notify({ title: 'VALIDACIÓN', text: 'Hubo un error al intentar registrarse, intentalo nuevamente', duration: 3500, type: 'error' })
        }
      }
    }

    setTimeout(() => {
      const script3 = document.createElement('script')
      script3.src = 'https://accounts.google.com/gsi/client'
      document.body.appendChild(script3)
    }, 50)
  },
}
</script>

<style>
.icon-input { position: relative; }
.icon-input input { padding-right: 40px; }
.icon-input .showHidePassword {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
